module.exports = __webpack_public_path__ + "img/Andrea Holz-Dahrenstaedt.78453ab7.jpg";